import { render, staticRenderFns } from "./Novelties.vue?vue&type=template&id=290a8fe2&scoped=true&lang=pug&"
import script from "./Novelties.vue?vue&type=script&lang=js&"
export * from "./Novelties.vue?vue&type=script&lang=js&"
import style0 from "./Novelties.vue?vue&type=style&index=0&id=290a8fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a8fe2",
  null
  
)

export default component.exports